<template>
  <header :style="this.$store.state.style">
    <!-- <img src="../../assets/images/cropwise-logo.png"> -->
    <img
      v-bind:src="
        require('../../assets/images/' +
          this.$store.state.style['--frame_logo'])
      "
    />
    <h1>{{ appName }}</h1>
    <div class="float-right">
      <b>{{ user.name }}</b>
      <button class="minimize-btn" v-on:click="minimizeIframe">
        <!-- <i class="fa fa-minus"></i> -->
        <img src="../../assets/images/minus-icon.png" />
      </button>
      <button class="close-btn" v-on:click="closeIframe">
        <!-- <i class="fa fa-times"></i> -->
        <img src="../../assets/images/close-icon.png" />
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: "FrameHeader",

  props: ["currentNodeId"],

  methods: {
    closeIframe: function () {
      this.$emit("iframe-closed");
    },

    minimizeIframe: function () {
      this.$emit("iframe-minimized");
    },

    getCurrentNode : function(){
      let userNodes = this.$store.state.userNodes.filter(
        (x) => x.id == this.currentNodeId
      );

      if(userNodes.length == 0){
        userNodes = this.$store.state.userNodes.filter(
          (x) => x.children.length>0 && x.children.find(c=>c.id == this.currentNodeId)
        );
      }
      
      return userNodes[0];
    }
  },
  computed: {
    appLogo: function () {
      let userNode = this.getCurrentNode();

      return require(`../../assets/images/${
        userNode ? userNode.icon : "PSS-logo2.png"
      }`);
    },
    appName: function () {
      let userNode = this.getCurrentNode();
      return userNode.name;
    },
    user: function () {
      return this.$AuthService.getUser();
    },
  },
  watch: {
    currentNodeId: function () {},
  },
};
</script>

<style>
header img {
  /* width: 220px;*/
}
header .minimize-btn,
header .close-btn {
  background: transparent;
  border: 0;
  color: #fff;
  line-height: 62.4px;
  margin: 0 20px;
  padding: 0;
  width: 20px;
  float: left;
  height: 43px;
}
header .minimize-btn:focus,
header .close-btn:focus {
  outline: none;
}
header {
  width: 100%;
  line-height: 4rem;
}
header img {
  max-height: 43px;
  float: left;
}
header > img {
  display: var(--card_logo_display);
}
header h1 {
  float: left;
  color: var(--main_color);
  font-size: 20px;
  line-height: 43px;
  padding-left: 20px;
  font-weight: bold;
  border-left: solid 3px #eee;
  margin-left: var(--header_h1_margin);
}
header b {
  float: left;
  font-size: 16px;
  color: #000;
  line-height: 43px;
  font-weight: 500;
}
</style>